module.exports = __webpack_public_path__ + "img/27.706df43b.jpg";